import React, { useState } from "react";

import { ExcpetRedirectAxios } from "../util/request";

const UserContext = React.createContext();

// Provider
function UserProvider(props) {
  const [isSignin, setIsSignin] = useState(false);
  const [user, setUser] = useState({
    avatarUrl: "",
    email: "",
    fakedEmail: false,
    name: "",
    token: "",
    userType: ""
  });
  const handleUser = () => {
    ExcpetRedirectAxios.get("/api/v1/user")
      .then(res => {
        setUser({ ...user, ...res.data });
        setIsSignin(true);
      })
      .catch(err => {
        setIsSignin(false);
      });
  };
  const state = { isSignin, user };
  const handler = { handleUser };
  return (
    <UserContext.Provider value={{ ...state, handler }}>
      {props.children}
    </UserContext.Provider>
  );
}

// Consumer
const UserConsumer = UserContext.Consumer;

export { UserContext, UserProvider, UserConsumer };
